import Vue from 'vue';
import _ from 'lodash';

function resetState({ state, createInitialState }) {
  const stateKeys = _.keys(state);
  const initialState = createInitialState();
  _.forEach(stateKeys, (key) => {
    Vue.set(state, key, _.get(initialState, key));
  });
}

// eslint-disable-next-line import/prefer-default-export
export const lsModuleHelpers = { resetState };
